export default {
    nome : 'Sistema de Gerenciamento de Marketplace',
    sigla : 'SGM'
};